
import { Options, prop, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import woodpacking from "@/app/ui/assets/svg/sti-dest-transit/woodpacking.svg";
import woodpackingEn from "@/app/ui/assets/svg/sti-dest-transit/woodpacking-en.svg";
class Props {
  isDangerousGoods = prop<boolean>({ type: Boolean, default: false });
  isWoodpacking = prop<boolean>({ type: Boolean, default: false });
  cityCode = prop<string>({
    type: String,
    default: "",
  });
  isBag = prop<boolean>({
    type: Boolean,
    default: false,
  });
}
@Options({})
export default class Transit extends Vue.with(Props) {
  get accountIsForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  get woodpackingAsset() {
    return this.accountIsForeign ? woodpackingEn : woodpacking;
  }
}
